import { render, staticRenderFns } from "./DataChip.vue?vue&type=template&id=602a75f2"
import script from "./DataChip.vue?vue&type=script&lang=js"
export * from "./DataChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports